module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-grid/pay-monthly-grid.component.css
// module id = ./src/app/hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-grid/pay-monthly-grid.component.css
// module chunks = main